"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = createLayer;

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _propTypes = require("prop-types");

function createLayer(config) {
  var merged = Object.assign({}, config, {
    displayName: config.displayName || 'Layer',
    propTypes: Object.assign({
      innerRef: _propTypes.func,
      opacity: _propTypes.number.isRequired,
      version: _propTypes.any,
      visible: _propTypes.bool.isRequired,
      minZoom: _propTypes.number,
      maxZoom: _propTypes.number,
      zIndex: _propTypes.number
    }, config.propTypes),
    contextTypes: Object.assign({
      map: _propTypes.object.isRequired
    }, config.contextTypes),
    getDefaultProps: function getDefaultProps() {
      var props;

      if (config.getDefaultProps) {
        props = config.getDefaultProps.call(this);
      }

      return Object.assign({
        opacity: 1,
        visible: true
      }, props);
    },
    componentDidMount: function componentDidMount() {
      if (config.componentDidMount) {
        config.componentDidMount.apply(this, arguments);
      }

      this.layer.setOpacity(this.props.opacity);
      this.layer.setVisible(this.props.visible);
      this.layer.setZIndex(this.props.zIndex || 0);

      if (this.props.onPreRender) {
        this.layer.on('prerender', this.props.onPreRender);
      }

      if (this.props.onPostRender) {
        this.layer.on('postrender', this.props.onPostRender);
      }

      if ('minZoom' in this.props) {
        this.layer.setMinZoom(this.props.minZoom);
      }

      if ('maxZoom' in this.props) {
        this.layer.setMaxZoom(this.props.maxZoom);
      }

      this.context.map.addLayer(this.layer);

      if (this.props.innerRef) {
        this.props.innerRef(this.layer);
      }
    },
    componentDidUpdate: function componentDidUpdate(prevProps) {
      if (config.componentDidUpdate) {
        config.componentDidUpdate.apply(this, arguments);
      }

      if (this.props.version !== prevProps.version) {
        var source = this.layer.getSource();

        if (source) {
          source.changed();
        }
      }

      if (this.props.opacity !== prevProps.opacity) {
        this.layer.setOpacity(this.props.opacity);
      }

      if (this.props.visible !== prevProps.visible) {
        this.layer.setVisible(this.props.visible);
      }

      if (this.props.zIndex !== prevProps.zIndex) {
        this.layer.setZIndex(this.props.zIndex);
      }

      if (this.props.minZoom !== prevProps.minZoom) {
        this.layer.setMinZoom(this.props.minZoom);
      }

      if (this.props.maxZoom !== prevProps.maxZoom) {
        this.layer.setMaxZoom(this.props.maxZoom);
      }

      if (this.props.onPreRender !== prevProps.onPreRender) {
        if (prevProps.onPreRender) {
          this.layer.un('prerender', prevProps.onPreRender);
        }

        if (this.props.onPreRender) {
          this.layer.on('prerender', prevProps.onPreRender);
        }
      }

      if (this.props.onPostRender !== prevProps.onPostRender) {
        if (prevProps.onPostRender) {
          this.layer.un('postrender', prevProps.onPostRender);
        }

        if (this.props.onPostRender) {
          this.layer.on('postrender', prevProps.onPostRender);
        }
      }

      if (this.props.innerRef) {
        this.props.innerRef(this.layer);
      }
    },
    componentWillUnmount: function componentWillUnmount() {
      if (config.componentWillUnmount) {
        config.componentWillUnmount.apply(this, arguments);
      }

      if (this.props.onPreRender) {
        this.layer.un('prerender', this.props.onPreRender, this);
      }

      if (this.props.onPostRender) {
        this.layer.un('postrender', this.props.onPostRender, this);
      }

      this.context.map.removeLayer(this.layer);

      if (this.props.innerRef) {
        this.props.innerRef(null);
      }
    },
    render: function render() {
      return null;
    }
  });
  return (0, _createReactClass["default"])(merged);
}